import React, { ChangeEvent, ReactElement } from 'react';

type Props = {
  name: string
  defaultChecked?: boolean
  checked: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  offText?: string
  onText?: string
  disabled?: boolean
};

type State = {
};

class SwitchInput extends React.Component<Props, State> {
  state: State = {
  };

  render(): ReactElement {
    return (
      <label
        htmlFor={this.props.name}
        className="switch"
      >
        <div>
          <input
            type="checkbox"
            name={this.props.name}
            id={this.props.name}
            defaultChecked={this.props.defaultChecked}
            checked={this.props.checked}
            onChange={this.props.onChange}
            disabled={this.props.disabled}
          />
          <span className="slider" />
          {this.props.onText && <span className="on-text">{this.props.onText}</span>}
          {this.props.offText && <span className="off-text">{this.props.offText}</span>}
        </div>
      </label>
    );
  }
}

export default SwitchInput;
